<script lang="ts">
	export let y: number,
		x1: number,
		y1: number,
		x2: number,
		y2: number,
		strokeWidth: number,
		direction: 'forwards' | 'reverse' = 'forwards',
		color = 'primary',
		play = true,
		id: string = '';
</script>

<g {id} transform="translate(0 {y})">
	<line {x1} {y1} {x2} {y2} stroke-width={strokeWidth} stroke="white" fill="none" />
	{#if play}
		<line
			{x1}
			{y1}
			{x2}
			{y2}
			stroke-width={strokeWidth - 1}
			stroke="var(--color-{color})"
			style="animation-direction: {direction}"
			fill="none"
			class="path-anime"
			stroke-dasharray="100 5"
			stroke-dashoffset="105"
		/>
	{/if}
</g>

<style>
	.path-anime {
		animation: dash 0.75s linear 0.201s infinite;
	}
	@keyframes dash {
		to {
			stroke-dashoffset: 0;
		}
	}
</style>
